export const AUTO_FETCH_ENABLED_KEY = 'lightdash-explorer-auto-fetch-enabled';
export const AUTO_FETCH_ENABLED_DEFAULT = false;
